var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpiral1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 412.72 193.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        mix-blend-mode: hard-light;\n      }\n\n      .cls-5 {\n        isolation: isolate;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 412.72,
    height: 193.18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M412,181.96c-.31-.39-.25-.96.14-1.27s.96-.25,1.27.14.25.96-.14,1.27-.96.25-1.27-.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 411.85,
    cy: 177.72,
    r: 0.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M410.59,174.53c-.3-.38-.24-.93.14-1.23s.93-.24,1.23.14.24.93-.14,1.23-.93.24-1.23-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M410.32,170.75c-.29-.37-.23-.91.14-1.2s.91-.23,1.2.14.23.91-.14,1.2-.91.23-1.2-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M410.33,166.97c-.29-.36-.23-.89.13-1.18s.89-.23,1.18.13.23.89-.13,1.18-.89.23-1.18-.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 411.27,
    cy: 162.68,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 411.84,
    cy: 158.95,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 412.7,
    cy: 155.27,
    r: 0.79
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M412.17,192.82c-.44-.27-.58-.85-.31-1.29s.85-.58,1.29-.31.58.85.31,1.29c-.27.44-.85.58-1.29.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M410.51,189.11c-.43-.27-.57-.83-.3-1.27s.83-.57,1.27-.3.57.83.3,1.27-.83.57-1.27.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M409.12,185.28c-.42-.26-.56-.82-.3-1.24.26-.42.82-.56,1.24-.3s.56.82.3,1.24c-.26.42-.82.56-1.24.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 408.5,
    cy: 180.6,
    r: 0.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 407.71,
    cy: 176.62,
    r: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 407.22,
    cy: 172.59,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 407.05,
    cy: 168.53,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 407.19,
    cy: 164.47,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 407.64,
    cy: 160.44,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 408.4,
    cy: 156.45,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 409.46,
    cy: 152.53,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 410.82,
    cy: 148.7,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 412.46,
    cy: 144.99,
    r: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 408.05,
    cy: 192.1,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 406.39,
    cy: 188.07,
    r: 0.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 405.04,
    cy: 183.92,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 404.01,
    cy: 179.67,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 403.31,
    cy: 175.36,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 402.94,
    cy: 171.01,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 402.9,
    cy: 166.65,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 403.2,
    cy: 162.29,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 403.82,
    cy: 157.97,
    r: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M404.63,154.43c-.4-.08-.65-.47-.57-.86s.47-.65.86-.57.65.47.57.86-.47.65-.86.57Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 406.06,
    cy: 149.54,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 407.66,
    cy: 145.48,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 409.57,
    cy: 141.55,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 411.77,
    cy: 137.78,
    r: 0.65
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 403.15,
    cy: 192.08,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 401.51,
    cy: 187.69,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 400.2,
    cy: 183.18,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 399.24,
    cy: 178.58,
    r: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M398.76,174.71c-.43.06-.83-.23-.9-.66-.06-.43.23-.83.66-.9s.83.23.9.66-.23.83-.66.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 398.4,
    cy: 169.24,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 398.52,
    cy: 164.55,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 399.01,
    cy: 159.88,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 399.85,
    cy: 155.26,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 401.04,
    cy: 150.72,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 402.57,
    cy: 146.28,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 404.43,
    cy: 141.97,
    r: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 406.62,
    cy: 137.82,
    r: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 409.12,
    cy: 133.84,
    r: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M412,130.64c-.31.05-.61-.17-.65-.48s.17-.61.48-.65.61.17.65.48-.17.61-.48.65Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 397.91,
    cy: 191.96,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 396.31,
    cy: 187.18,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 395.08,
    cy: 182.28,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 394.23,
    cy: 177.3,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 393.76,
    cy: 172.28,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 393.68,
    cy: 167.23,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 393.98,
    cy: 162.19,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 394.66,
    cy: 157.19,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 395.72,
    cy: 152.26,
    r: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M397.45,147.96c-.3.16-.67.05-.84-.25s-.05-.67.25-.84.67-.05.84.25.05.67-.25.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M399.25,143.23c-.29.16-.65.05-.81-.24s-.05-.65.24-.81.65-.05.81.24.05.65-.24.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M401.4,138.65c-.28.15-.62.05-.78-.23s-.05-.62.23-.78.62-.05.78.23.05.62-.23.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M403.89,134.24c-.27.14-.6.05-.74-.22s-.05-.6.22-.74.6-.05.74.22.05.6-.22.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M406.72,130.05c-.26.14-.57.04-.71-.21s-.04-.57.21-.71.57-.04.71.21.04.57-.21.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M409.86,126.08c-.24.13-.55.04-.68-.2s-.04-.55.2-.68.55-.04.68.2.04.55-.2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.29,122.37c-.23.13-.52.04-.65-.19s-.04-.52.19-.65.52-.04.65.19.04.52-.19.65Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 392.4,
    cy: 191.67,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 390.85,
    cy: 186.47,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 389.7,
    cy: 181.17,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 388.96,
    cy: 175.79,
    r: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.13,170.81c-.24.27-.66.3-.94.06s-.3-.66-.06-.94.66-.3.94-.06.3.66.06.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.2,165.37c-.23.26-.64.29-.9.06s-.29-.64-.06-.9.64-.29.9-.06.29.64.06.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.68,159.95c-.22.25-.61.28-.87.05s-.28-.61-.05-.87.61-.28.87-.05.28.61.05.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M390.59,154.58c-.22.24-.59.27-.83.05s-.27-.59-.05-.83.59-.27.83-.05.27.59.05.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M391.9,149.31c-.21.23-.56.26-.8.05s-.26-.56-.05-.8.56-.26.8-.05.26.56.05.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M393.61,144.15c-.2.22-.54.24-.76.05s-.24-.54-.05-.76.54-.24.76-.05.24.54.05.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M395.72,139.13c-.19.21-.52.23-.73.04s-.23-.52-.04-.73.52-.23.73-.04.23.52.04.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M398.19,134.29c-.18.2-.49.22-.69.04s-.22-.49-.04-.69.49-.22.69-.04.22.49.04.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M401.02,129.66c-.17.19-.47.21-.66.04s-.21-.47-.04-.66.47-.21.66-.04.21.47.04.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M404.19,125.25c-.16.18-.44.2-.63.04s-.2-.44-.04-.63.44-.2.63-.04.2.44.04.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M407.69,121.1c-.15.17-.42.19-.59.04s-.19-.42-.04-.59.42-.19.59-.04.19.42.04.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M411.51,117.24c-.14.16-.39.18-.56.03s-.18-.39-.03-.56.39-.18.56-.03.18.39.03.56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M387.19,191.44c-.14.35-.54.53-.89.39s-.53-.54-.39-.89.54-.53.89-.39.53.54.39.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M385.69,185.78c-.13.34-.52.51-.86.37s-.51-.52-.37-.86.52-.51.86-.37.51.52.37.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M384.63,180.03c-.13.33-.5.49-.82.36s-.49-.5-.36-.82.5-.49.82-.36.49.5.36.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M384.01,174.21c-.12.31-.48.47-.79.34s-.47-.48-.34-.79.48-.47.79-.34.47.48.34.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M383.84,168.37c-.12.3-.46.45-.75.33s-.45-.46-.33-.75.46-.45.75-.33.45.46.33.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M384.12,162.53c-.11.29-.43.43-.72.31s-.43-.43-.31-.72.43-.43.72-.31.43.43.31.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M384.84,156.73c-.11.27-.41.41-.69.3s-.41-.41-.3-.69.41-.41.69-.3.41.41.3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M386,151.01c-.1.26-.39.39-.65.28s-.39-.39-.28-.65.39-.39.65-.28.39.39.28.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M387.58,145.39c-.1.24-.37.36-.62.27s-.36-.37-.27-.62.37-.36.62-.27.36.37.27.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.6,139.91c-.09.23-.35.34-.58.25s-.34-.35-.25-.58.35-.34.58-.25.34.35.25.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M392.03,134.6c-.09.22-.33.32-.55.24s-.32-.33-.24-.55.33-.32.55-.24.32.33.24.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M394.86,129.5c-.08.2-.31.3-.51.22s-.3-.31-.22-.51.31-.3.51-.22.3.31.22.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M398.07,124.64c-.07.19-.29.28-.48.21s-.28-.29-.21-.48.29-.28.48-.21.28.29.21.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M401.65,120.04c-.07.18-.27.26-.45.19s-.26-.27-.19-.45.27-.26.45-.19.26.27.19.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M405.57,115.72c-.06.16-.25.24-.41.18s-.24-.25-.18-.41.25-.24.41-.18.24.25.18.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M409.8,111.72c-.06.15-.23.22-.38.16s-.22-.23-.16-.38.23-.22.38-.16.22.23.16.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M381.02,190.43c0,.33-.28.59-.61.58s-.59-.28-.58-.61.28-.59.61-.58.59.28.58.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M379.61,184.31c0,.31-.27.56-.58.55s-.56-.27-.55-.58.27-.56.58-.55.56.27.55.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M378.67,178.1c0,.3-.26.53-.55.53s-.53-.26-.53-.55.26-.53.55-.53.53.26.53.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M378.21,171.84c0,.28-.24.51-.53.5s-.51-.24-.5-.53.24-.51.53-.5.51.24.5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M378.23,165.56c0,.27-.23.48-.5.47s-.48-.23-.47-.5.23-.48.5-.47.48.23.47.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M378.73,159.31c0,.25-.22.45-.47.44s-.45-.22-.44-.47.22-.45.47-.44.45.22.44.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M379.72,153.12c0,.24-.2.42-.44.42s-.42-.2-.42-.44.2-.42.44-.42.42.2.42.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M381.18,147.02c0,.22-.19.39-.41.39s-.39-.19-.39-.41.19-.39.41-.39.39.19.39.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M383.1,141.05c0,.2-.18.37-.38.36s-.37-.18-.36-.38.18-.37.38-.36.37.18.36.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M385.47,135.25c0,.19-.16.34-.35.33s-.34-.16-.33-.35.16-.34.35-.33.34.16.33.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M388.28,129.66c0,.17-.15.31-.32.3s-.31-.15-.3-.32.15-.31.32-.3.31.15.3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M391.5,124.29c0,.16-.13.28-.29.28s-.28-.13-.28-.29.13-.28.29-.28.28.13.28.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M395.13,119.19c0,.14-.12.25-.26.25s-.25-.12-.25-.26.12-.25.26-.25.25.12.25.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 398.9,
    cy: 114.37,
    r: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M403.49,109.89c0,.11-.09.2-.2.19s-.2-.09-.19-.2.09-.2.2-.19.2.09.19.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 408,
    cy: 105.74,
    r: 0.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 412.22,
    cy: 95.5,
    r: 2.51,
    transform: "translate(100.45 381.59) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M374.38,189.16c.09.26-.05.53-.31.62s-.53-.05-.62-.31.05-.53.31-.62.53.05.62.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M373.1,182.54c.08.24-.05.5-.29.58s-.5-.05-.58-.29.05-.5.29-.58.5.05.58.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M372.33,175.85c.08.22-.05.47-.27.54s-.47-.05-.54-.27.05-.47.27-.54.47.05.54.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M372.08,169.11c.07.21-.04.43-.25.5s-.43-.04-.5-.25.04-.43.25-.5.43.04.5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M372.34,162.38c.06.19-.04.4-.23.46s-.4-.04-.46-.23.04-.4.23-.46.4.04.46.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M373.12,155.69c.06.18-.04.37-.21.43s-.37-.04-.43-.21.04-.37.21-.43.37.04.43.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M374.41,149.08c.05.16-.03.33-.19.39s-.33-.03-.39-.19.03-.33.19-.39.33.03.39.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M376.19,142.59c.05.14-.03.3-.17.35s-.3-.03-.35-.17.03-.3.17-.35.3.03.35.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 378.24,
    cy: 136.34,
    r: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M381.22,130.12c.04.11-.02.23-.14.27s-.23-.02-.27-.14.02-.23.14-.27.23.02.27.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 384.26,
    cy: 124.27,
    r: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M388.1,118.57c.03.08-.02.17-.1.19s-.17-.02-.19-.1.02-.17.1-.19.17.02.19.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M392.18,113.24c.02.06-.01.13-.08.15s-.13-.01-.15-.08.01-.13.08-.15.13.01.15.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 396.58,
    cy: 108.26,
    r: 0.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 401.47,
    cy: 103.61,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 406.69,
    cy: 99.34,
    r: 0.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 384.75,
    cy: 112.37,
    r: 2.7,
    transform: "translate(74.59 366.26) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 389.36,
    cy: 106.77,
    r: 2.66,
    transform: "translate(81.22 367.63) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 394.39,
    cy: 101.53,
    r: 2.63,
    transform: "translate(87.72 369.5) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 399.8,
    cy: 96.7,
    r: 2.6,
    transform: "translate(94.06 371.86) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 405.57,
    cy: 92.3,
    r: 2.57,
    transform: "translate(10.39 222.05) rotate(-31)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 411.66,
    cy: 88.35,
    r: 2.53,
    transform: "translate(37.38 281.18) rotate(-39.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M367.38,187.57c.12.16.1.38-.06.51s-.38.1-.51-.06-.1-.38.06-.51.38-.1.51.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M366.25,180.42c.11.14.09.35-.05.46s-.35.09-.46-.05-.09-.35.05-.46.35-.09.46.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M365.67,173.21c.1.13.08.31-.05.42s-.31.08-.42-.05-.08-.31.05-.42.31-.08.42.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 365.43,
    cy: 166.13,
    r: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M366.16,158.76c.08.1.06.24-.04.32s-.24.06-.32-.04-.06-.24.04-.32.24-.06.32.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 367.09,
    cy: 151.73,
    r: 0.2,
    transform: "translate(-17.12 252.52) rotate(-37.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M368.86,144.56c.06.07.04.17-.03.23s-.17.04-.23-.03-.04-.17.03-.23.17-.04.23.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M371.03,137.66c.05.06.04.14-.02.18s-.14.04-.18-.02-.04-.14.02-.18.14-.04.18.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 373.64,
    cy: 131.02,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 376.87,
    cy: 124.52,
    r: 0.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 380.58,
    cy: 118.29,
    r: 0.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 363.2,
    cy: 139.52,
    r: 2.9,
    transform: "translate(42.82 360.29) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 365.8,
    cy: 132.16,
    r: 2.86,
    transform: "translate(50.02 359.24) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 368.96,
    cy: 125.03,
    r: 2.83,
    transform: "translate(57.28 358.74) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 372.65,
    cy: 118.15,
    r: 2.79,
    transform: "translate(64.56 358.79) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 376.86,
    cy: 111.58,
    r: 2.76,
    transform: "translate(91.98 382.35) rotate(-60.04)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 381.56,
    cy: 105.36,
    r: 2.72,
    transform: "translate(62.62 339.8) rotate(-51.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 386.73,
    cy: 99.52,
    r: 2.69,
    transform: "translate(52.3 317.74) rotate(-47.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 392.33,
    cy: 94.09,
    r: 2.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 398.33,
    cy: 89.1,
    r: 2.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 404.7,
    cy: 84.59,
    r: 2.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 411.39,
    cy: 80.58,
    r: 2.55,
    transform: "translate(73.14 328.2) rotate(-47.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 359.83,
    cy: 185.79,
    r: 0.21,
    transform: "translate(14.39 397.14) rotate(-58.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M358.99,177.89c.08.05.11.16.06.24s-.16.11-.24.06-.11-.16-.06-.24.16-.11.24-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M358.64,170.12c.07.04.09.13.05.19s-.13.09-.19.05-.09-.13-.05-.19.13-.09.19-.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 358.84,
    cy: 162.45,
    r: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 359.71,
    cy: 154.7,
    r: 0.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 361.17,
    cy: 147.03,
    r: 0.04
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 351.42,
    cy: 174.88,
    r: 3.12,
    transform: "translate(8.53 365.94) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 351.34,
    cy: 166.49,
    r: 3.08,
    transform: "translate(15.42 362.23) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 351.9,
    cy: 158.12,
    r: 3.04,
    transform: "translate(22.57 359.05) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 353.1,
    cy: 149.82,
    r: 3,
    transform: "translate(29.94 356.43) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 354.94,
    cy: 141.63,
    r: 2.97,
    transform: "translate(197.8 489.98) rotate(-87.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 357.4,
    cy: 133.61,
    r: 2.93,
    transform: "translate(80.47 396.09) rotate(-63.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 360.47,
    cy: 125.81,
    r: 2.89,
    transform: "translate(53.66 353.03) rotate(-55.76)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 364.14,
    cy: 118.26,
    r: 2.85,
    transform: "translate(-18.61 108.92) rotate(-16.59)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 368.37,
    cy: 111.02,
    r: 2.81,
    transform: "translate(-16.35 108.13) rotate(-16.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 373.14,
    cy: 104.12,
    r: 2.78,
    transform: "translate(-14.24 107.46) rotate(-16.09)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 378.42,
    cy: 97.6,
    r: 2.74,
    transform: "translate(84.85 355.57) rotate(-55.77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 384.19,
    cy: 91.51,
    r: 2.7,
    transform: "translate(191.96 436.5) rotate(-74.27)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 390.4,
    cy: 85.87,
    r: 2.66,
    transform: "translate(-8.82 106.17) rotate(-15.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 397.02,
    cy: 80.72,
    r: 2.62,
    transform: "translate(163.28 411.64) rotate(-66.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 404.02,
    cy: 76.09,
    r: 2.59,
    transform: "translate(210.51 438.83) rotate(-72.59)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 411.35,
    cy: 72.02,
    r: 2.55,
    transform: "translate(181.57 420.73) rotate(-66.55)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 353.46,
    cy: 191.5,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 352.12,
    cy: 183.22,
    r: 0.04
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 344.99,
    cy: 189,
    r: 3.23,
    transform: "translate(-5.91 366.78) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 343.84,
    cy: 180.05,
    r: 3.19,
    transform: "translate(-39.01 116.26) rotate(-18.18)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 343.38,
    cy: 171.04,
    r: 3.15,
    transform: "translate(97.3 465.34) rotate(-76.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 343.61,
    cy: 162.03,
    r: 3.11,
    transform: "translate(47.19 399.63) rotate(-63.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 344.54,
    cy: 153.05,
    r: 3.07,
    transform: "translate(-29.13 203.13) rotate(-31.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 346.15,
    cy: 144.18,
    r: 3.03,
    transform: "translate(-24.38 201.77) rotate(-31.45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 348.44,
    cy: 135.45,
    r: 2.98,
    transform: "translate(-19.65 200.8) rotate(-31.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 351.38,
    cy: 126.92,
    r: 2.94,
    transform: "translate(84.36 388.22) rotate(-64.24)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 354.96,
    cy: 118.65,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 359.16,
    cy: 110.66,
    r: 2.86,
    transform: "translate(-5.87 200.08) rotate(-30.89)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 363.96,
    cy: 103.03,
    r: 2.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 369.33,
    cy: 95.78,
    r: 2.78,
    transform: "translate(244.62 456.37) rotate(-85.46)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 375.24,
    cy: 88.96,
    r: 2.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 381.66,
    cy: 82.62,
    r: 2.7,
    transform: "translate(-6.44 125.89) rotate(-18.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M388.15,74.17c1.45-.22,2.8.78,3.02,2.23s-.78,2.8-2.23,3.02-2.8-.78-3.02-2.23c-.22-1.45.78-2.8,2.23-3.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M395.47,68.93c1.43-.21,2.76.77,2.98,2.2.21,1.43-.77,2.76-2.2,2.98-1.43.21-2.76-.77-2.98-2.2-.21-1.43.77-2.76,2.2-2.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M403.18,64.27c1.41-.21,2.72.76,2.93,2.17s-.76,2.72-2.17,2.93c-1.41.21-2.72-.76-2.93-2.17s.76-2.72,2.17-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M411.22,60.22c1.38-.21,2.67.75,2.88,2.13.21,1.38-.75,2.67-2.13,2.88s-2.67-.75-2.88-2.13c-.21-1.38.75-2.67,2.13-2.88Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 337.53,
    cy: 195.42,
    r: 3.3,
    transform: "translate(-40.12 292.87) rotate(-44.54)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 335.9,
    cy: 185.86,
    r: 3.25,
    transform: "translate(-33.99 288.6) rotate(-44.48)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 335,
    cy: 176.2,
    r: 3.21,
    transform: "translate(-27.59 284.83) rotate(-44.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 334.84,
    cy: 166.5,
    r: 3.17,
    transform: "translate(74.17 434.62) rotate(-72.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 335.41,
    cy: 156.82,
    r: 3.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 336.72,
    cy: 147.21,
    r: 3.08,
    transform: "translate(-7.21 276.67) rotate(-44.24)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 338.76,
    cy: 137.73,
    r: 3.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 341.52,
    cy: 128.43,
    r: 2.99,
    transform: "translate(-19.09 72.84) rotate(-11.85)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 344.99,
    cy: 119.37,
    r: 2.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 349.14,
    cy: 110.6,
    r: 2.9,
    transform: "translate(-1.77 215.45) rotate(-34.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M352.59,99.67c1.39-.75,3.12-.24,3.88,1.15.75,1.39.24,3.12-1.15,3.88-1.39.75-3.12.24-3.88-1.15-.75-1.39-.24-3.12,1.15-3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M358.06,91.69c1.37-.74,3.07-.24,3.82,1.13s.24,3.07-1.13,3.82c-1.37.74-3.07.24-3.82-1.13-.74-1.37-.24-3.07,1.13-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.14,84.15c1.34-.73,3.03-.23,3.76,1.11.73,1.34.23,3.03-1.11,3.76-1.34.73-3.03.23-3.76-1.11s-.23-3.03,1.11-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M370.77,77.09c1.32-.72,2.98-.23,3.7,1.09s.23,2.98-1.09,3.7-2.98.23-3.7-1.09c-.72-1.32-.23-2.98,1.09-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M377.92,70.55c1.3-.71,2.93-.23,3.64,1.08.71,1.3.23,2.93-1.08,3.64-1.3.71-2.93.23-3.64-1.08-.71-1.3-.23-2.93,1.08-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M385.55,64.57c1.28-.7,2.88-.22,3.58,1.06s.22,2.88-1.06,3.58c-1.28.7-2.88.22-3.58-1.06s-.22-2.88,1.06-3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M393.61,59.19c1.26-.68,2.83-.22,3.52,1.04.68,1.26.22,2.83-1.04,3.52-1.26.68-2.83.22-3.52-1.04s-.22-2.83,1.04-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M402.07,54.44c1.24-.67,2.79-.21,3.46,1.02.67,1.24.21,2.79-1.02,3.46s-2.79.21-3.46-1.02-.21-2.79,1.02-3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M410.87,50.36c1.22-.66,2.74-.21,3.4,1.01.66,1.22.21,2.74-1.01,3.4-1.22.66-2.74.21-3.4-1.01-.66-1.22-.21-2.74,1.01-3.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 327.49,
    cy: 192.38,
    r: 3.31,
    transform: "translate(-12.4 361.91) rotate(-56.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 326.06,
    cy: 182.05,
    r: 3.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 325.43,
    cy: 171.64,
    r: 3.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 325.6,
    cy: 161.22,
    r: 3.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 326.57,
    cy: 150.83,
    r: 3.12,
    transform: "translate(-3.78 293.19) rotate(-48.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M326.04,138.52c1.12-1.27,3.07-1.39,4.34-.27,1.27,1.12,1.39,3.07.27,4.34-1.12,1.27-3.07,1.39-4.34.27-1.27-1.12-1.39-3.07-.27-4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M328.63,128.44c1.11-1.25,3.02-1.37,4.27-.26s1.37,3.02.26,4.27c-1.11,1.25-3.02,1.37-4.27.26-1.25-1.11-1.37-3.02-.26-4.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M331.99,118.58c1.09-1.23,2.97-1.35,4.2-.26,1.23,1.09,1.35,2.97.26,4.2-1.09,1.23-2.97,1.35-4.2.26s-1.35-2.97-.26-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M336.1,109.01c1.07-1.21,2.92-1.33,4.14-.25,1.21,1.07,1.33,2.92.25,4.14-1.07,1.21-2.92,1.33-4.14.25s-1.33-2.92-.25-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.92,99.78c1.05-1.19,2.88-1.31,4.07-.25s1.31,2.88.25,4.07-2.88,1.31-4.07.25c-1.19-1.05-1.3-2.88-.25-4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M346.43,90.93c1.04-1.17,2.83-1.28,4-.25s1.28,2.83.25,4-2.83,1.28-4,.25c-1.17-1.04-1.28-2.83-.25-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M352.6,82.53c1.02-1.15,2.78-1.26,3.94-.24s1.26,2.78.24,3.94c-1.02,1.15-2.78,1.26-3.94.24-1.15-1.02-1.26-2.78-.24-3.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M359.4,74.62c1-1.13,2.74-1.24,3.87-.24,1.13,1,1.24,2.74.24,3.87-1,1.13-2.74,1.24-3.87.24-1.13-1-1.24-2.74-.24-3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M366.79,67.26c.99-1.11,2.69-1.22,3.8-.23,1.11.99,1.22,2.69.23,3.8-.99,1.11-2.69,1.22-3.8.23-1.11-.99-1.22-2.69-.23-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M374.73,60.49c.97-1.1,2.64-1.2,3.74-.23,1.1.97,1.2,2.64.23,3.74-.97,1.1-2.64,1.2-3.74.23s-1.2-2.64-.23-3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M383.17,54.34c.95-1.08,2.59-1.18,3.67-.23s1.18,2.59.23,3.67-2.59,1.18-3.67.23-1.18-2.59-.23-3.67Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 393.97,
    cy: 50.56,
    r: 2.55,
    transform: "translate(98.25 315.73) rotate(-49.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M401.35,44.08c.92-1.04,2.5-1.13,3.54-.22s1.13,2.5.22,3.54c-.92,1.04-2.5,1.13-3.54.22-1.04-.92-1.13-2.5-.22-3.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 412.82,
    cy: 41.64,
    r: 2.46,
    transform: "translate(127.46 342.84) rotate(-52.31)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M313.49,187.53c.67-1.7,2.59-2.53,4.28-1.86,1.7.67,2.53,2.59,1.86,4.28-.67,1.7-2.59,2.53-4.28,1.86-1.7-.67-2.53-2.59-1.86-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M312.41,176.4c.66-1.67,2.55-2.49,4.22-1.84,1.67.66,2.49,2.55,1.84,4.22-.66,1.67-2.55,2.49-4.22,1.84s-2.49-2.55-1.84-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M312.18,165.2c.65-1.65,2.51-2.45,4.15-1.81,1.65.65,2.45,2.51,1.81,4.15-.65,1.65-2.51,2.45-4.15,1.81s-2.45-2.51-1.81-4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M312.81,154.02c.64-1.62,2.47-2.42,4.09-1.78,1.62.64,2.42,2.47,1.78,4.09-.64,1.62-2.47,2.42-4.09,1.78s-2.42-2.47-1.78-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M314.29,142.92c.63-1.59,2.43-2.38,4.02-1.75s2.38,2.43,1.75,4.02c-.63,1.59-2.43,2.38-4.02,1.75-1.59-.63-2.38-2.43-1.75-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.6,131.95c.62-1.57,2.39-2.34,3.95-1.72s2.34,2.39,1.72,3.95c-.62,1.57-2.39,2.34-3.95,1.72s-2.34-2.39-1.72-3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M319.74,121.19c.61-1.54,2.35-2.3,3.89-1.69s2.3,2.35,1.69,3.89-2.35,2.3-3.89,1.69c-1.54-.61-2.3-2.35-1.69-3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M323.7,110.7c.6-1.52,2.31-2.26,3.82-1.66s2.26,2.31,1.66,3.82-2.31,2.26-3.82,1.66-2.26-2.31-1.66-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M328.47,100.55c.59-1.49,2.27-2.22,3.76-1.63,1.49.59,2.22,2.27,1.63,3.76-.59,1.49-2.27,2.22-3.76,1.63s-2.22-2.27-1.63-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M334,90.78c.58-1.46,2.23-2.18,3.69-1.61,1.46.58,2.18,2.23,1.61,3.69-.58,1.46-2.23,2.18-3.69,1.61s-2.18-2.23-1.61-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.27,81.47c.57-1.44,2.19-2.14,3.63-1.58s2.14,2.19,1.58,3.63c-.57,1.44-2.19,2.14-3.63,1.58-1.44-.57-2.14-2.19-1.58-3.63Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 349.79,
    cy: 73.67,
    r: 2.74,
    transform: "translate(122.54 349.6) rotate(-62.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M354.86,64.41c.54-1.38,2.11-2.07,3.49-1.52s2.07,2.11,1.52,3.49-2.11,2.07-3.49,1.52c-1.38-.54-2.07-2.11-1.52-3.49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 365.55,
    cy: 57.73,
    r: 2.64,
    transform: "translate(156.1 362.84) rotate(-64.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M371.88,49.76c.52-1.33,2.03-1.99,3.36-1.46,1.33.52,1.99,2.03,1.46,3.36-.52,1.33-2.03,1.99-3.36,1.46s-1.99-2.03-1.46-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M381.18,43.44c.51-1.31,1.99-1.95,3.3-1.43,1.31.51,1.95,1.99,1.43,3.3s-1.99,1.95-3.3,1.43-1.95-1.99-1.43-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M390.93,37.84c.5-1.28,1.95-1.91,3.23-1.41s1.91,1.95,1.41,3.23c-.5,1.28-1.95,1.91-3.23,1.41-1.28-.5-1.91-1.95-1.41-3.23Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 403.36,
    cy: 33.9,
    r: 2.44,
    transform: "translate(186.19 375.49) rotate(-62.36)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 413.81,
    cy: 29.83,
    r: 2.39,
    transform: "translate(194.4 381.95) rotate(-62.2)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M303.24,196.3c.05-1.84,1.58-3.29,3.42-3.25,1.84.05,3.29,1.58,3.25,3.42-.05,1.84-1.58,3.29-3.42,3.25-1.84-.05-3.29-1.58-3.25-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M301.54,184.37c.05-1.81,1.55-3.24,3.36-3.19,1.81.05,3.24,1.55,3.19,3.36-.05,1.81-1.55,3.24-3.36,3.19s-3.24-1.55-3.19-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M300.76,172.34c.05-1.78,1.53-3.19,3.31-3.14s3.19,1.53,3.14,3.31c-.05,1.78-1.53,3.19-3.31,3.14-1.78-.05-3.19-1.53-3.14-3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M300.91,160.29c.05-1.75,1.5-3.13,3.25-3.09,1.75.05,3.13,1.5,3.09,3.25-.05,1.75-1.5,3.13-3.25,3.09-1.75-.05-3.13-1.5-3.09-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M301.98,148.27c.04-1.72,1.47-3.08,3.19-3.03,1.72.04,3.08,1.47,3.03,3.19-.04,1.72-1.47,3.08-3.19,3.03s-3.08-1.47-3.03-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M303.98,136.37c.04-1.69,1.45-3.02,3.14-2.98s3.02,1.45,2.98,3.14c-.04,1.69-1.45,3.02-3.14,2.98-1.69-.04-3.02-1.45-2.98-3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M306.89,124.66c.04-1.66,1.42-2.97,3.08-2.93,1.66.04,2.97,1.42,2.93,3.08s-1.42,2.97-3.08,2.93-2.97-1.42-2.93-3.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 313.65,
    cy: 113.28,
    r: 2.95,
    transform: "translate(128.08 390.35) rotate(-76.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.36,102.06c.04-1.6,1.37-2.86,2.97-2.82s2.86,1.37,2.82,2.97c-.04,1.6-1.37,2.86-2.97,2.82-1.6-.04-2.86-1.37-2.82-2.97Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 323.71,
    cy: 91.38,
    r: 2.84,
    transform: "translate(162.56 386.62) rotate(-77.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M327.17,80.99c.04-1.54,1.32-2.75,2.86-2.71s2.75,1.32,2.71,2.86c-.04,1.54-1.32,2.75-2.86,2.71s-2.75-1.32-2.71-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M334.24,71.19c.04-1.51,1.29-2.7,2.8-2.66,1.51.04,2.7,1.29,2.66,2.8-.04,1.51-1.29,2.7-2.8,2.66-1.51-.04-2.7-1.29-2.66-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.04,61.95c.04-1.48,1.27-2.65,2.75-2.61s2.65,1.27,2.61,2.75-1.27,2.65-2.75,2.61-2.65-1.27-2.61-2.75Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 353.15,
    cy: 53.39,
    r: 2.62,
    transform: "translate(197.45 374.83) rotate(-72.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 362.21,
    cy: 45.44,
    r: 2.57,
    transform: "translate(205.78 375.27) rotate(-71.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 371.86,
    cy: 38.2,
    r: 2.51,
    transform: "translate(202.41 371.41) rotate(-68.91)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 382.03,
    cy: 31.73,
    r: 2.46,
    transform: "translate(208.87 373.74) rotate(-67.89)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 392.68,
    cy: 26.07,
    r: 2.4,
    transform: "translate(202.05 370.36) rotate(-64.83)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 403.73,
    cy: 21.24,
    r: 2.35,
    transform: "translate(213.83 378.15) rotate(-65)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M290.42,193.48c-.58-1.72.35-3.59,2.08-4.17s3.59.35,4.17,2.08-.35,3.59-2.08,4.17-3.59-.35-4.17-2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M289.05,180.57c-.57-1.69.35-3.52,2.04-4.09,1.69-.57,3.52.35,4.09,2.04.57,1.69-.35,3.52-2.04,4.09s-3.52-.35-4.09-2.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 291.69,
    cy: 166.59,
    r: 3.17,
    transform: "translate(-3.67 6.59) rotate(-1.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M289.3,154.62c-.55-1.63.33-3.4,1.96-3.94s3.4.33,3.94,1.96c.55,1.63-.33,3.4-1.96,3.94s-3.4-.33-3.94-1.96Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 293.8,
    cy: 140.76,
    r: 3.06,
    transform: "translate(-3.26 7.02) rotate(-1.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M293.48,128.99c-.53-1.57.32-3.27,1.89-3.79,1.57-.53,3.27.32,3.79,1.89.53,1.57-.32,3.27-1.89,3.79s-3.27-.32-3.79-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M297.02,116.48c-.52-1.54.31-3.2,1.85-3.72s3.2.31,3.72,1.85-.31,3.2-1.85,3.72-3.2-.31-3.72-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M301.5,104.28c-.51-1.51.31-3.14,1.82-3.65s3.14.31,3.65,1.82-.31,3.14-1.82,3.65c-1.51.51-3.14-.31-3.65-1.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 309.58,
    cy: 91.55,
    r: 2.82,
    transform: "translate(183.01 388.54) rotate(-83.39)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 315.81,
    cy: 80.18,
    r: 2.76,
    transform: "translate(187.67 379.76) rotate(-81.09)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 322.9,
    cy: 69.32,
    r: 2.7,
    transform: "translate(180.8 367.45) rotate(-76.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 330.8,
    cy: 59.04,
    r: 2.64,
    transform: "translate(181.48 360.08) rotate(-73.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 339.48,
    cy: 49.41,
    r: 2.59,
    transform: "translate(167.35 346.15) rotate(-68.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 348.87,
    cy: 40.47,
    r: 2.53,
    transform: "translate(183.11 350.1) rotate(-68.46)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 358.91,
    cy: 32.27,
    r: 2.47,
    transform: "translate(179.35 344.71) rotate(-65.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 369.56,
    cy: 24.86,
    r: 2.41,
    transform: "translate(140.17 315.68) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 380.73,
    cy: 18.28,
    r: 2.35,
    transform: "translate(150.46 322.03) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 392.36,
    cy: 12.56,
    r: 2.29,
    transform: "translate(148.9 320.51) rotate(-53.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 404.41,
    cy: 7.75,
    r: 2.23,
    transform: "translate(106.91 281.79) rotate(-43.75)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiral1);
export default __webpack_public_path__ + "static/media/spiral-1.c07089a179c16cecb99ee75eb7cc7e0f.svg";
export { ForwardRef as ReactComponent };